<template>
  <div class="w-full">
    <div class="w-full flex flex-col-reverse md:flex-row mb-5 justify-between">
      <div class="flex">
        <vs-button
          icon-pack="feather"
          type="border"
          icon="icon-filter"
          class="mr-3"
          @click="isFilter = !isFilter"
          >Filter</vs-button
        >
        <vs-button
          icon-pack="feather"
          type="border"
          icon="icon-sliders"
          class="mr-3"
          @click="isSort = !isSort"
          >Sort</vs-button
        >
      </div>

      <div class="flex">
        <vs-input
          class="w-full mb-3 md:mb-0"
          icon-pack="feather"
          icon="icon-search"
          placeholder="Cari Pegawai"
          v-model="search"
        />
      </div>
    </div>

    <vx-card title="Filter Berdaskan" class="my-5" v-if="isFilter">
      <div class="w-full flex flex-col md:flex-row">
        <div class="w-full md:w-1/3 px-3 mb-4">
          <div class="mb-2">Waktu</div>
          <vs-select :options="filters.waktu" v-model="waktu"></vs-select>
        </div>
        <div class="w-full md:w-1/3 px-3">
          <div class="mb-2">Bidang</div>
          <vs-select :options="filters.bidang" v-model="bidang"></vs-select>
        </div>
      </div>
    </vx-card>

    <vx-card title="Urutkan Berdaskan" class="my-5" v-if="isSort">
      <div class="w-full">
        <div class="w-full md:w-1/3 px-3">
          <div class="mb-2">Total Kehadiran</div>
          <vs-select :options="sort.total" v-model="sorting"></vs-select>
        </div>
      </div>
    </vx-card>

    <global-table :totalPage="metaData.total_page" @reloadData="setPage">
      <template #thead>
        <global-th left="0" class="sticky-col">No.</global-th>
        <global-th>Nama</global-th>
        <global-th>Jumlah Kehadiran</global-th>
        <global-th>WFO</global-th>
        <global-th>WFH</global-th>
        <global-th>Telat</global-th>
        <global-th>Lebih Awal</global-th>
        <global-th></global-th>
      </template>
      <template #tbody>
        <global-tr v-for="(report, index) in reports" :key="index">
          <global-td>{{ report.index }}</global-td>
          <global-td>
            <global-user
              :src="
                report.avatar ||
                `https://pixinvent.com/demo/vuesax-vuexy-vuejs-admin-dashboard-template/demo-1/img/avatar-s-6.0c96c10d.jpg`
              "
              :name="report.name"
              :subname="`${report.location} ( ${report.position} )`"
            ></global-user>
          </global-td>
          <global-td>{{ report.total }}</global-td>
          <global-td
            >{{ report.wfo
            }}<small class="text-grey">{{
              `(${((report.wfo / report.total) * 100).toFixed(1)} %)`
            }}</small></global-td
          >
          <global-td
            >{{ report.wfh
            }}<small class="text-grey">{{
              `(${((report.wfh / report.total) * 100).toFixed(1)} %)`
            }}</small></global-td
          >
          <global-td
            >{{ report.late
            }}<small class="text-grey">{{
              `(${((report.late / report.total) * 100).toFixed(1)} %)`
            }}</small></global-td
          >
          <global-td
            >{{ report.early_clock_out
            }}<small class="text-grey">{{
              `(${((report.early_clock_out / report.total) * 100).toFixed(
                1
              )} %)`
            }}</small></global-td
          >
          <global-td
            ><vs-button
              @click="clickedShow(report.uuid)"
              size="small"
              icon-pack="feather"
              icon="icon-eye"
              >Lihat</vs-button
            ></global-td
          >
        </global-tr>
      </template>
    </global-table>
  </div>
</template>

<script>
import VsSelect from "vue-select";
import { digofHttp } from "@/axios";
export default {
  components: {
    VsSelect,
  },
  data() {
    return {
      search: "",
      timeOut: 0,
      isFilter: false,
      filters: {
        bidang: [
          {
            label: "Ekonomi",
            value: "Ekonomi",
          },
        ],
        waktu: [
          {
            label: "Bulan Ini",
            value: "this_month",
          },
          {
            label: "Bulan Lalu",
            value: "last_month",
          },
          {
            label: "Minggu Ini",
            value: "this_week",
          },
          {
            label: "Minggu Lalu",
            value: "last_week",
          },
        ],
      },
      waktu: {
        label: "Bulan Ini",
        value: "this_month",
      },
      isSort: false,
      sort: {
        total: [
          {
            label: "Besar ke Kecil",
            value: "desc",
          },
          {
            label: "Kecil ke Besar",
            value: "asc",
          },
        ],
      },
      reports: [],
      metaData: {
        search: null,
        page: 1,
        total_page: 0,
        limit: null,
        sort: null,
        limitationType: null,
      },
      bidang: {
        value: "",
        label: "Semua Bidang",
      },
      sorting: {
        label: "Besar ke Kecil",
        value: "desc",
      },
    };
  },
  mounted() {
    this.loadReport();
    this.loadBidang();
  },
  methods: {
    clickedShow(uuid) {
      this.$router.push({
        name: "laporan-absensi-pegawai",
        params: { uuid },
      });
    },
    loadBidang() {
      digofHttp.get(`attendance/bidang`).then((r) => {
        this.filters.bidang = r.data.data.bidang;
        this.filters.bidang.splice(0, 0, { value: "", label: "Semua Bidang" });
      });
    },
    loadReport() {
      this.$vs.loading();
      digofHttp
        .get(
          `attendance/reports?page=${this.metaData.page}&search=${this.search}&limitationType=${this.waktu.value}&bidang=${this.bidang.value}&sort=${this.sorting.value}`
        )
        .then((r) => {
          this.reports = r.data.data.reports;
          this.metaData.total_page = r.data.meta.total_page;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    setPage(page) {
      this.metaData.page = page;
      this.loadReport();
    },
  },
  watch: {
    search() {
      let self = this;
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        self.loadReport();
      }, 800);
    },
    waktu() {
      this.loadReport();
    },
    bidang() {
      this.loadReport();
    },
    sorting() {
      this.loadReport();
    },
  },
};
</script>
